module.exports = __webpack_public_path__ + "img/cover-chamado.6520b26e.png";